import { takeScreenshotAndSave } from '@in3d/core';

export const ScreenshotButton = () => {
  return (
    <button className="control-btn" onClick={() => takeScreenshotAndSave('download')}>
      <img src={`/assets/scene/camera.svg`} alt="music" />
    </button>
  );
};
